declare global {
  interface Window {
    shopFeAppConf: object;
  }
}

export default {
  debug: true,
  counter: 0,
  currentVariantId: 0,
  activeImageIndex: 0,
  images: [],
  variants: [],
  extconf: window.shopFeAppConf,
  cartCount: null,
};
